export type PickupPoint = {
  id: string;
  shortName: string;
  name: string;
  address: string;
  hours: string;
  eta: string;
  rating?: string;
  lat: number;
  lng: number;
  active: boolean;
  note?: string;
};

export const pickupPoints: PickupPoint[] = [
  {
    id: "naberezhnaya-bridge",
    shortName: "Набережная · за мостом",
    name: "CoffeeTrack · Набережная · за мостом",
    address: "Набережная Туры · за мостом",
    hours: "12:00–01:00",
    eta: "7–10 мин",
    rating: "4,9",

    // Временные координаты по присланной Яндекс.Карте.
    lat: 57.164624,
    lng: 65.523217,

    active: true,
  },

  {
    id: "naberezhnaya-square",
    shortName: "Набережная · у сквера",
    name: "CoffeeTrack · Набережная · у сквера",
    address: "Набережная Туры · Исторический сквер",
    hours: "12:00–01:00",
    eta: "7–10 мин",
    rating: "4,9",

    // Временные координаты по присланной точке 2ГИС.
    // Потом подвинем метку буквально до нужного места.
    lat: 57.161617,
    lng: 65.523956,

    active: true,
  },
];

// COFFEETRACK_ACTIVE_POINTS_V319
//
// One canonical active-point view for:
// - customer UI
// - localStorage restore
// - repeat order
// - server order validation
//
export const activePickupPoints =
  pickupPoints.filter(
    (point) => point.active,
  );

if (!activePickupPoints.length) {
  throw new Error(
    "CoffeeTrack requires at least one active pickup point",
  );
}

export const defaultPickupPoint =
  activePickupPoints[0] as PickupPoint;

export function findActivePickupPoint(
  pointId: string,
) {
  return activePickupPoints.find(
    (point) =>
      point.id === pointId,
  );
}

export function findActivePickupPointByName(
  pointName: string,
) {
  return activePickupPoints.find(
    (point) =>
      point.name === pointName,
  );
}
